import React from 'react';

export const DivorceTextMax = () => {
  return (
    <>
      <p>Що входить в роботу:</p>
      <p>✔️консультації на всьому етапі справи;</p>
      <p>✔️підготовка позовної заяви;</p>
      <p>✔️формування справи для подачі в суд;</p>
      <p>✔️подача документів в суд;</p>
      <p>
        ✔️підготовка клопотання про розгляд справи без Вашої участі та інших
        процесуальних документів, за необхідністю;
      </p>
      <p>на судове засідання Вам йти не потрібно буде;</p>
      <p>
        ✔️отримання рішення суду; Окремо сплачується судовий збір в державу, на
        рахунок суду - 908 грн.
      </p>
    </>
  );
};
